<template>
  <div id="app" v-watermark>
    <keep-alive :include="keepAlive" >
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "app",
  computed: {
    keepAlive () {
      return ['Follow','Home']
    }
  }
};
</script>
<style lang="less">
@import "./style/base.less";
</style>
